import { createErrorWrapper } from '../utils';

export const LOADING_ERROR = 'SETTINGS.LOADING_ERROR';

export const loadingErr = createErrorWrapper(LOADING_ERROR, 'Не удалось загрузить настройки пользователя');
